import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { Message } from "../../../model/Auth";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";

export interface UpdateCategoryUseCase {
  invoke: (category: Category) => Promise<ResponseState<Message>>;
}

export class UpdateCategoryUseCaseImpl implements UpdateCategoryUseCase {
  private categoryRepository: CategoryRepository;

  constructor(categoryRepository: CategoryRepository) {
    this.categoryRepository = categoryRepository;
  }

  async invoke(category: Category): Promise<ResponseState<Message>> {
    try {
      let response = await this.categoryRepository.updateCategory(category);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
